export default __webpack_public_path__ + "images/pin-judges.png?8ff9ef6629a3f38b6bbbe391237e0e73";